/**
 * @author Omar BERRABEH
 * @license Givaudan
 */

import { FALLBACK_LOCAL, localOfLanguage } from '../consts/locale.const';
import { LOCALE } from '../enum/locale';

export function getlocaleOfLanguage(language: string | LOCALE): LOCALE {
  if (language) {
    if (!language.split('-')[1]) {
      return localOfLanguage[language];
    }
    return language as LOCALE;
  }
  return FALLBACK_LOCAL;
}
